module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_14.17fd2312.webp";